import React from "react";

export default ({ width = 12, height = 12, ...props }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00065 1.16667C5.06765 1.16667 3.50065 2.73367 3.50065 4.66667C3.50065 6.59966 5.06765 8.16667 7.00065 8.16667C8.93365 8.16667 10.5007 6.59966 10.5007 4.66667C10.5007 2.73367 8.93365 1.16667 7.00065 1.16667ZM2.33398 4.66667C2.33398 2.08934 4.42332 0 7.00065 0C9.57798 0 11.6673 2.08934 11.6673 4.66667C11.6673 7.244 9.57798 9.33333 7.00065 9.33333C4.42332 9.33333 2.33398 7.244 2.33398 4.66667Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.13413 7.51685C9.45349 7.47448 9.74674 7.69903 9.78911 8.0184L10.4949 13.3384C10.5244 13.5604 10.4241 13.7797 10.2369 13.9027C10.0497 14.0256 9.80862 14.0306 9.61656 13.9153L7.00001 12.3454L4.38347 13.9153C4.19139 14.0306 3.95029 14.0256 3.76308 13.9027C3.57586 13.7797 3.4756 13.5604 3.50509 13.3383L4.21093 8.02415C4.25334 7.70479 4.54662 7.48028 4.86599 7.5227C5.18535 7.56512 5.40985 7.8584 5.36744 8.17776L4.82094 12.2923L6.69989 11.1649C6.88462 11.0541 7.11541 11.0541 7.30014 11.1649L9.17928 12.2924L8.63258 8.17184C8.59021 7.85247 8.81476 7.55923 9.13413 7.51685Z"
      />
    </svg>
  );
};
